import { createFileRoute } from "@tanstack/react-router";
import { WhyItCosts } from "./varfor-kostar-det";

export const Route = createFileRoute("/es/por-que-cuesta")({
  head: () => ({
    meta: [
      { title: "Por qué cuesta algo | Sellavo" },
      { name: "description", content: "Qué pagas en Sellavo y a qué se destina el dinero." },
      { property: "og:title", content: "Por qué cuesta algo | Sellavo" },
      { property: "og:description", content: "Qué pagas en Sellavo y a qué se destina el dinero." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/por-que-cuesta" }],
  }),
  component: WhyItCosts,
});
